export const LABELS = 'LABELS';
export const LABELS_SUCCESS = `${LABELS}_SUCCESS`;
export const LABELS_FAILURE = `${LABELS}_FAILURE`;
